<template>
  <div class="service-selector--block">
    <ion-list>
      <form-select
        class="service-selector"
        :select-data="list"
        :value="currentApi"
        interface-flag="popover"
        @update:value="onUpdateValue"
      />
    </ion-list>
    <ion-note>{{ $t('auth.logIn.apiChangeNote') }}</ion-note>
  </div>
</template>

<script setup lang="ts">
import { IonList, IonNote } from '@ionic/vue';
import { computed, ComputedRef, ref } from 'vue';

import { FormSelect } from '@/components';
import { getServiceList } from '@/api';
import { useAuthStore } from '@/store';
import { FormSelectDataModel } from '@/types';

const currentApi = ref<string>(useAuthStore().host);

const list: ComputedRef<FormSelectDataModel> = computed(() => ({
  title: 'API',
  value: currentApi.value,
  options: getServiceList(useAuthStore().host),
}));

const onUpdateValue = (host: string) => {
  currentApi.value = host;
  useAuthStore().setHost(currentApi.value);
};
</script>

<style scoped lang="scss">
.service-selector {
  &--block {
    display: flex;
    flex-direction: column;
    margin-top: app-padding(lg);
    ion-note {
      margin-inline: app-padding(lg);
      text-align: start;
      margin-top: app-padding(md);
    }
    ion-list {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
  & :deep(ion-select) {
    width: 100%;
    justify-content: space-between;
    padding-left: 0;
    padding-right: 0;
  }
  & :deep(ion-select::part(text)) {
    width: 100%;
    max-width: 100%;
    justify-content: space-between;
  }
  & :deep(.in-item) {
    max-width: 100%;
  }
}
</style>
